import type {
  Locale,
  LocaleMessages,
  LocaleNamespace,
} from "shared-core/services/i18n-types.ts";

type LocaleModule = { default?: LocaleMessages } | LocaleMessages;

const localeModules = import.meta.glob<LocaleModule>(
  "../../../shared-core/src/assets/locales/*/*.json",
);

export async function loadLocaleNamespaceFromVite(
  locale: Locale,
  namespace: LocaleNamespace,
): Promise<LocaleMessages> {
  const path = `../../../shared-core/src/assets/locales/${locale}/${namespace}.json`;
  const loader = localeModules[path];

  if (!loader) {
    return {};
  }

  const mod = await loader();
  return (mod.default ?? mod ?? {}) as LocaleMessages;
}
